import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { restaurantInfo } from '../data/menuData';

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/menu', label: 'Menu' },
    { path: '/infos', label: 'Infos' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/10" data-testid="navigation-header">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <nav className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_gourmet-chaumont/artifacts/ygast60c_IMG_8674.png" 
              alt="Délices de Chaumont Logo"
              className="w-10 h-10 md:w-12 md:h-12 rounded-full object-contain"
            />
            <span className="font-heading text-base md:text-xl tracking-wide text-white uppercase">
              Délices <span className="text-orange-500">de</span> Chaumont
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link font-accent text-sm uppercase tracking-widest transition-colors ${
                  isActive(link.path)
                    ? 'text-orange-500'
                    : 'text-gray-300 hover:text-white'
                }`}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
            
            {/* Call Button Desktop */}
            <a href={restaurantInfo.phoneLink} data-testid="nav-call-button-desktop">
              <Button className="bg-green-600 hover:bg-green-700 text-white font-bold uppercase tracking-wider px-6 py-2 rounded-md transition-all hover:scale-105 flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <span className="hidden lg:inline">Commander</span>
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-white/10 animate-fade-in" data-testid="mobile-menu">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-accent text-lg uppercase tracking-wider py-2 ${
                    isActive(link.path) ? 'text-orange-500' : 'text-gray-300'
                  }`}
                  onClick={() => setIsOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </Link>
              ))}
              <a href={restaurantInfo.phoneLink} className="mt-2" data-testid="mobile-call-button">
                <Button className="w-full bg-green-600 hover:bg-green-700 text-white font-bold uppercase tracking-wider py-3 rounded-md flex items-center justify-center gap-2">
                  <Phone className="w-5 h-5" />
                  Appeler pour commander
                </Button>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navigation;
